export const Tool = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8512 4.62317C10.6969 4.78055 10.6105 4.99213 10.6105 5.21249C10.6105 5.43286 10.6969 5.64444 10.8512 5.80181L12.1982 7.14883C12.3556 7.30309 12.5671 7.38949 12.7875 7.38949C13.0079 7.38949 13.2195 7.30309 13.3768 7.14883L16.5507 3.97492C16.9741 4.91042 17.1022 5.95271 16.9182 6.9629C16.7341 7.97308 16.2466 8.90319 15.5205 9.62926C14.7944 10.3553 13.8643 10.8429 12.8541 11.0269C11.8439 11.211 10.8017 11.0828 9.86616 10.6595L4.04874 16.4769C3.71381 16.8118 3.25956 17 2.78591 17C2.31226 17 1.858 16.8118 1.52308 16.4769C1.18816 16.142 1 15.6877 1 15.2141C1 14.7404 1.18816 14.2862 1.52308 13.9513L7.34051 8.13384C6.91718 7.19834 6.789 6.15605 6.97306 5.14586C7.15712 4.13567 7.64467 3.20557 8.37074 2.4795C9.09681 1.75343 10.0269 1.26588 11.0371 1.08182C12.0473 0.897759 13.0896 1.02594 14.0251 1.44927L10.8596 4.61475L10.8512 4.62317Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
